import React from 'react';

import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Box from '@mui/material/Box'

import pluralize from 'pluralize';

interface ISpecialization {
    handleChange: (event: SelectChangeEvent) => void;
    selected: string;

    specs: string[];
}

const Specializations: React.FC<ISpecialization> = ({
    selected,
    handleChange,
    specs,
}) => {



    return (
        <Box sx={{ minWidth: 200 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Specialization</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selected}
            label="Specialization"
            onChange={handleChange}
          >
            {specs.map((tag, index) => (
              <MenuItem key={'specialization-' + index} value={tag}>{tag}</MenuItem>
            ))}


          </Select>
          <FormHelperText>
            Currently viewing {pluralize(selected)}
          </FormHelperText>
        </FormControl>
      </Box>
    )
}

export default Specializations;
